import { render, staticRenderFns } from "./buylist.vue?vue&type=template&id=3f0914ea&scoped=true"
import script from "./buylist.vue?vue&type=script&lang=js"
export * from "./buylist.vue?vue&type=script&lang=js"
import style0 from "./buylist.vue?vue&type=style&index=0&id=3f0914ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0914ea",
  null
  
)

export default component.exports